
import "es6-promise/auto";

//css assets
import "bootstrap/dist/css/bootstrap.css";
import "../assets/sass/paper-dashboard.scss";

export default {}
